import definitions from "../../../definitions";
import NPCAlan from "./NPCAlan";
import NPCArthur from "./NPCArthur";
import NPCBadger from "./NPCBadger";
import NPCBarbarian from "./NPCBarbarian";
import NPCBarKeep from "./NPCBarKeep";
import NPCBarry from "./NPCBarry";
import NPCBatWitch from "./NPCBatWitch";
import NPCBoar from "./NPCBoar";
import NPCBoaris from "./NPCBoaris";
import NPCBobbin from "./NPCBobbin";
import NPCCedric from "./NPCCedric";
import NPCChefSow from "./NPCChefSow";
import NPCDaisy from "./NPCDaisy";
import NPCDitzi from "./NPCDitzi";
import NPCDucky from "./NPCDucky";
import NPCDwight from "./NPCDwight";
import NPCFeral from "./NPCFeral";
import NPCFishGuard from "./NPCFishGuard";
import NPCFoxThief from "./NPCFoxThief";
import NPCFritzi from "./NPCFritzi";
import NPCGiantChick from "./NPCGiantChick";
import NPCGiantSpider from "./NPCGiantSpider";
import NPCGlitzi from "./NPCGlitzi";
import NPCGoblin from "./NPCGoblin";
import NPCGunther from "./NPCGunther";
import NPCHansi from "./NPCHansi";
import NPCHenchCat1 from "./NPCHenchCat1";
import NPCHenchCat2 from "./NPCHenchCat2";
import NPCJezabel from "./NPCJezabel";
import NPCKingAxalotyl from "./NPCKingAxalotyl";
import NPCKingKnut from "./NPCKingKnut";
import NPCKingSvanson from "./NPCKingSvanson";
import NPCLars from "./NPCLars";
import NPCLisbet from "./NPCLisbet";
import NPCMaggie from "./NPCMaggie";
import NPCMotherDuck from "./NPCMotherDuck";
import NPCNanny from "./NPCNanny";
import NPCNobleSwan1 from "./NPCNobleSwan1";
import NPCNobleSwan2 from "./NPCNobleSwan2";
import NPCOskar from "./NPCOskar";
import NPCPercy from "./NPCPercy";
import NPCPony from "./NPCPony";
import NPCPrincessSvandelyne from "./NPCPrincessSvandelyne";
import NPCPrincessSyllabob from "./NPCPrincessSyllabob";
import NPCPrinceSvan from "./NPCPrinceSvan";
import NPCQueenGrizabella from "./NPCQueenGrizabella";
import NPCQueenKristine from "./NPCQueenKristine";
import NPCQueenSvania from "./NPCQueenSvania";
import NPCRaymond from "./NPCRaymond";
import NPCRoger from "./NPCRoger";
import NPCRulf from "./NPCRulf";
import NPCSpritzi from "./NPCSpritzi";
import NPCSusan from "./NPCSusan";
import NPCSuzie from "./NPCSuzie";
import NPCTatiana from "./NPCTatiana";
import NPCToby from "./NPCToby";
import NPCWeasel from "./NPCWeasel";
import NPCWolf from "./NPCWolf";
import NPCMrFairy from "./NPCMrFairy";
import NPCBrian from "./NPCBrian";
import NPCAllanTheDwarf from "./NPCAllanTheDwarf";
import NPCGnomeBear from "./NPCGnomeBear";

export default class NPCFactory {
    /**
     * @param {string} id
     * @returns {NPC}
     */
    static create(id) {
        switch (id) {
            case definitions.NPC_ID.ALAN: {
                return new NPCAlan();
            }
            case definitions.NPC_ID.ALLAN_THE_DWARF: {
                return new NPCAllanTheDwarf();
            }
            case definitions.NPC_ID.ARTHUR: {
                return new NPCArthur();
            }
            case definitions.NPC_ID.BARRY: {
                return new NPCBarry();
            }
            case definitions.NPC_ID.BADGER: {
                return new NPCBadger();
            }
            case definitions.NPC_ID.BOAR: {
                return new NPCBoar();
            }
            case definitions.NPC_ID.BARBARIAN: {
                return new NPCBarbarian();
            }
            case definitions.NPC_ID.BAR_KEEP: {
                return new NPCBarKeep();
            }
            case definitions.NPC_ID.BATWITCH: {
                return new NPCBatWitch();
            }
            case definitions.NPC_ID.BOARIS: {
                return new NPCBoaris();
            }
            case definitions.NPC_ID.BOBBIN: {
                return new NPCBobbin();
            }
            case definitions.NPC_ID.BRIAN: {
                return new NPCBrian();
            }
            case definitions.NPC_ID.CEDRIC: {
                return new NPCCedric();
            }
            case definitions.NPC_ID.CHICK_OF_DOOM: {
                return new NPCGiantChick();
            }
            case definitions.NPC_ID.CHEF_SOW: {
                return new NPCChefSow();
            }
            case definitions.NPC_ID.DITZI: {
                return new NPCDitzi();
            }
            case definitions.NPC_ID.DAISY: {
                return new NPCDaisy();
            }
            case definitions.NPC_ID.DUCKY: {
                return new NPCDucky();
            }
            case definitions.NPC_ID.DWIGHT: {
                return new NPCDwight();
            }
            case definitions.NPC_ID.FISH_GUARD: {
                return new NPCFishGuard();
            }
            case definitions.NPC_ID.FOX_THIEF_1: {
                return new NPCFoxThief(definitions.NPC_ID.FOX_THIEF_1);
            }
            case definitions.NPC_ID.FOX_THIEF_2: {
                return new NPCFoxThief(definitions.NPC_ID.FOX_THIEF_2);
            }
            case definitions.NPC_ID.FOX_THIEF_3: {
                return new NPCFoxThief(definitions.NPC_ID.FOX_THIEF_3);
            }
            case definitions.NPC_ID.FRITZI: {
                return new NPCFritzi();
            }
            case definitions.NPC_ID.GIANT_SPIDER: {
                return new NPCGiantSpider();
            }
            case definitions.NPC_ID.GNOME_BEAR: {
                return new NPCGnomeBear();
            }
            case definitions.NPC_ID.GLITZI: {
                return new NPCGlitzi();
            }
            case definitions.NPC_ID.GUNTHER: {
                return new NPCGunther();
            }
            case definitions.NPC_ID.GOBLIN: {
                return new NPCGoblin();
            }
            case definitions.NPC_ID.HANSI: {
                return new NPCHansi();
            }
            case definitions.NPC_ID.HENCH_CAT_1: {
                return new NPCHenchCat1();
            }
            case definitions.NPC_ID.HENCH_CAT_2: {
                return new NPCHenchCat2();
            }
            case definitions.NPC_ID.JEZABEL: {
                return new NPCJezabel();
            }
            case definitions.NPC_ID.KING_AXALOTYL: {
                return new NPCKingAxalotyl();
            }
            case definitions.NPC_ID.KING_KNUT: {
                return new NPCKingKnut();
            }
            case definitions.NPC_ID.KING_SVANSON: {
                return new NPCKingSvanson();
            }
            case definitions.NPC_ID.LARS: {
                return new NPCLars();
            }
            case definitions.NPC_ID.LISBET: {
                return new NPCLisbet();
            }
            case definitions.NPC_ID.MAGGIE: {
                return new NPCMaggie();
            }
            case definitions.NPC_ID.MOTHER_DUCK: {
                return new NPCMotherDuck();
            }
            case definitions.NPC_ID.MR_FAIRY: {
                return new NPCMrFairy();
            }
            case definitions.NPC_ID.NANNY: {
                return new NPCNanny();
            }
            case definitions.NPC_ID.NOBLESWAN_1: {
                return new NPCNobleSwan1();
            }
            case definitions.NPC_ID.NOBLESWAN_2: {
                return new NPCNobleSwan2();
            }
            case definitions.NPC_ID.OSKAR: {
                return new NPCOskar();
            }
            case definitions.NPC_ID.PERCY: {
                return new NPCPercy();
            }
            case definitions.NPC_ID.PONY_1: {
                return new NPCPony(definitions.NPC_ID.PONY_1);
            }
            case definitions.NPC_ID.PONY_2: {
                return new NPCPony(definitions.NPC_ID.PONY_2);
            }
            case definitions.NPC_ID.PONY_3: {
                return new NPCPony(definitions.NPC_ID.PONY_3);
            }
            case definitions.NPC_ID.PRINCE_SVAN: {
                return new NPCPrinceSvan();
            }
            case definitions.NPC_ID.PRINCESS_SVANDELYNE: {
                return new NPCPrincessSvandelyne();
            }
            case definitions.NPC_ID.PRINCESS_SYLLABOB: {
                return new NPCPrincessSyllabob();
            }
            case definitions.NPC_ID.QUEEN_KRISTINE: {
                return new NPCQueenKristine();
            }
            case definitions.NPC_ID.QUEEN_GRIZBELLA: {
                return new NPCQueenGrizabella();
            }
            case definitions.NPC_ID.QUEEN_SVANIA: {
                return new NPCQueenSvania();
            }
            case definitions.NPC_ID.RAYMOND: {
                return new NPCRaymond();
            }
            case definitions.NPC_ID.RULF: {
                return new NPCRulf();
            }
            case definitions.NPC_ID.ROGER: {
                return new NPCRoger();
            }
            case definitions.NPC_ID.FERAL: {
                return new NPCFeral();
            }
            case definitions.NPC_ID.SPRITZI: {
                return new NPCSpritzi();
            }
            case definitions.NPC_ID.SUZIE: {
                return new NPCSuzie();
            }
            case definitions.NPC_ID.SUSAN: {
                return new NPCSusan();
            }
            case definitions.NPC_ID.TATIANA: {
                return new NPCTatiana();
            }
            case definitions.NPC_ID.TOBY: {
                return new NPCToby();
            }
            case definitions.NPC_ID.WOLF: {
                return new NPCWolf();
            }
            case definitions.NPC_ID.WEASEL: {
                return new NPCWeasel();
            }
        }
        return null;
    }
}